export const formatDate = (date) => {
  // YYYY-MM-DD date-only strings must be formatted without `new Date(...)`,
  // which would interpret them as UTC midnight and shift the day when the
  // viewer is in a timezone behind UTC.
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split("-");
    return `${month}/${day}/${year}`;
  }
  if (isNaN(new Date(date).getDate())) {
    return date;
  }
  const day = String(new Date(date).getDate()).padStart(2, "0");
  const month = String(new Date(date).getMonth() + 1).padStart(2, "0");
  const year = new Date(date).getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatDateTime = (date) => {
  console.log(date);

  if (isNaN(new Date(date).getDate())) {
    return date;
  }

  return new Date(date).toLocaleString("en-US");
};
